import { ILocationSuggestion } from 'transfix-ui/components/SuggestLocation'
import { object, string, number, InferType } from 'yup'
import { CarrierApplication } from 'apps/marketplace/apiTypes/staplesHeadhaulLanes'

export const StaplesLaneModalSchema = object({
  pickupLocation: object<ILocationSuggestion>().required(),
  deliveryLocation: object<ILocationSuggestion>().required(),
  pickupPostalCode: string().nullable().notRequired(),
  deliveryPostalCode: string().nullable().notRequired(),
  carrierApplication: object<CarrierApplication>().nullable().required(),
  dailyTrucks: number()
    .nullable()
    .notRequired()
    .positive('Please enter a positive number')
    .transform((v, o) => (o === '' ? null : v)),
  weeklyTrucks: number()
    .nullable()
    .notRequired()
    .positive('Please enter a positive number')
    .transform((v, o) => (o === '' ? null : v)),
  pickupWindow: string().nullable().notRequired(),
  deliveryWindow: string().nullable().notRequired(),
  pickupLatitude: string().nullable().notRequired(),
  pickupLongitude: string().nullable().notRequired(),
  deliveryLatitude: string().nullable().notRequired(),
  deliveryLongitude: string().nullable().notRequired(),
  notes: string().nullable().notRequired(),
})

export type TStaplesLaneModalSchema = InferType<typeof StaplesLaneModalSchema>
